import createApiService from "../../http";
import {
  // FETCH_VIDEOS,
  ADD_VIDEOS,
  ADD_VIDEOS_FILE,
  FETCH_VIDEO_FOR_ADMIN,
  GET_SINGLE_VIDEO,
} from "./endpoints";
import getStory from '../../story';

// export const fetchVideosService = (params) => createApiService({
//     endpoint: FETCH_VIDEOS,
//     method: 'get',
//     options: {
//         params: {
//             ...params
//         }
//     }
// });

export const fetchVideosService =  (params) =>  getStory('', {
  search_term: params?.searchTerm,
  page: params?.page,
  per_page: params?.count,
  filter_query: {
    country: {
      in_array: params.country
    }
  },
  starts_with: 'media',
});


export const deleteVideoService = (token, params) =>
  createApiService({
    endpoint: '/video',
    method: "delete",
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        ...params,
      },
    },
  });


  export const fetchSingleVideoService = id => createApiService({
    endpoint: `${GET_SINGLE_VIDEO}/${id}`,
    method: 'get',
  })

export const fetchVideoForAdminService = (params) => createApiService({
    endpoint: FETCH_VIDEO_FOR_ADMIN,
    method: 'get',
    options: {
        params: {
            ...params
        }
    }
});

export const addVideoViaLinkService = (token) =>
  createApiService({
    endpoint: ADD_VIDEOS,
    method: "post",
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
export const addVideoViaFileService = (token) =>
  createApiService({
    endpoint: ADD_VIDEOS_FILE,
    method: "post",
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });